// frontend/src/components/settings/CategorySourceSelect.jsx
//
// Where Item.product_category comes from (core.models.Store.CategorySource):
// the shared Shopify taxonomy, or the product types the merchant maintains.
// One picker with the description of the shown value under it, rendered by
// Store settings' Product categories card (where a change queues a rebuild)
// and by the install setup step.

import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@mui/material';

const HELP_KEY = {
  taxonomy: 'storeSettings.categorySource_taxonomyHelp',
  product_type: 'storeSettings.categorySource_productTypeHelp',
};

export default function CategorySourceSelect({ value, onChange, disabled = false }) {
  const { t } = useTranslation();
  return (
    <TextField
      select
      label={t('storeSettings.categorySourceLabel')}
      value={value}
      onChange={onChange}
      size="small"
      fullWidth
      disabled={disabled}
      helperText={t(HELP_KEY[value])}
    >
      <MenuItem value="taxonomy">{t('storeSettings.categorySource_taxonomy')}</MenuItem>
      <MenuItem value="product_type">{t('storeSettings.categorySource_productType')}</MenuItem>
    </TextField>
  );
}
